import { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover, Tooltip } from '@mui/material';

import { authContext } from '../../../routes';
import axiosInstance from '../../../api';
import Iconify from '../../../components/iconify/Iconify';
import SERVER_API_URL from '../../../config';

export default function AccountPopover() {
  const { user, getUserData } = useContext(authContext);
  const dioceseLevel = user?.role?.permissions?.dioceseLevel.update;

  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const [avatar, setAvatar] = useState();

  useEffect(() => {
    const getAvatar = async () => {
      try {
        const response = await axiosInstance.get(`${SERVER_API_URL}/avatar/getAvatarById/${user.id}`, {
          responseType: 'blob',
        });
        if (response.status === 200) {
          const url = URL.createObjectURL(response.data);
          setAvatar(url);
        }
      } catch (e) {
        setAvatar(null);
      }
    };
    getAvatar();
  }, [user, setAvatar]);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleSettings = () => {
    setOpen(null);
    navigate('/dashboard/setting');
  };

  const handleProfile = () => {
    setOpen(null);
    navigate('/dashboard/profile');
  };

  const handleLogout = () => {
    localStorage.clear();
    getUserData();
    setOpen(null);

    setTimeout(() => {
      navigate('/login');
      // window.location.reload();
    }, 500);
  };

  return (
    <>
      <Tooltip title="መገለጫ" arrow>
        <IconButton
          onClick={handleOpen}
          sx={{
            p: 0,
            ...(open && {
              '&:before': {
                zIndex: 1,
                content: "''",
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                position: 'absolute',
                bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
              },
            }),
          }}
        >
          <Avatar src={`${avatar}`} alt={`${user && user.firstName}'s avatar`} />
        </IconButton>
      </Tooltip>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            backgroundColor: (theme) => theme.palette.mode === 'light' ? '#F9F9FB' : '#272424',
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user && user.firstName} {user && user.lastName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user && user.role.name}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          <MenuItem key="Profile" onClick={handleProfile}>
            <Iconify icon="carbon:user-avatar-filled" />
            <Iconify icon={'eva:profile-2-fill'} /> {' '} ፕሮፋይል
          </MenuItem>
          {dioceseLevel && (
            <MenuItem key="Settings" onClick={handleSettings}>
              <Iconify icon={'eva:settings-2-fill'} /> {' '} ቅንብሮች
            </MenuItem>
          )}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem key="logout" onClick={handleLogout} sx={{ m: 1 }}>
          <Iconify icon="ant-design:logout-outlined" /> ውጣ
        </MenuItem>
      </Popover>
    </>
  );
}
